import type { MainCategory } from "../types";
import { categoryLabels, subcategoryLabels } from "../lib/format";
import { categoryBadgeStyle } from "../charts/colors";

interface CategoryBadgeProps {
  category: MainCategory;
  subcategory?: string;
  showSubcategory?: boolean;
  onClick?: () => void;
}

export function CategoryBadge({
  category,
  subcategory,
  showSubcategory = false,
  onClick,
}: CategoryBadgeProps) {
  const mainLabel = categoryLabels[category] ?? category;
  const subLabel = subcategory
    ? subcategoryLabels[subcategory] ?? subcategory
    : null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${onClick ? "cursor-pointer hover:opacity-80" : ""}`}
      style={categoryBadgeStyle(category)}
      onClick={onClick}
    >
      {mainLabel}
      {showSubcategory && subLabel && (
        <span className="opacity-70">/ {subLabel}</span>
      )}
    </span>
  );
}
